import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const discountApi = createApi({
  reducerPath: "discountApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API + "financial/discount",
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.userSlice?.token;  
      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  endpoints: (builder) => ({

     validateDiscount: builder.mutation({
      query: ({ ...body }) => {
        const payload = { ...body };

        return {
          url: "/validate",
          method: "POST",
          body: payload,
        };
      },
    }),

    getUserDiscounts: builder.query({
      query: () => {
        // const payload = { ...body };

        return {
          url: "/my",
          method: "GET",
          // body: payload,
        };
      },
    }),
  }),
});

export const { useValidateDiscountMutation, useGetUserDiscountsQuery } = discountApi;
